import { render, staticRenderFns } from "./ScanPage.vue?vue&type=template&id=51318709&scoped=true&"
import script from "./ScanPage.vue?vue&type=script&lang=js&"
export * from "./ScanPage.vue?vue&type=script&lang=js&"
import style0 from "./ScanPage.vue?vue&type=style&index=0&id=51318709&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51318709",
  null
  
)

export default component.exports